(function () {
  var ROOT_SELECTOR = '[data-mobile-menu]';
  var OPEN_CLASS = 'mobile-menu--open';

  function getRoot() {
    return document.querySelector(ROOT_SELECTOR);
  }

  function getToggle() {
    return document.querySelector('[data-mobile-menu-toggle]');
  }

  function lockScroll(lock) {
    document.documentElement.classList.toggle('mobile-menu-lock', lock);
  }

  function onKeydown(event) {
    if (event.key === 'Escape') closeMenu();
  }

  function positionBelowHeader(root) {
    var header = document.querySelector('.site-header');
    if (header) root.style.top = header.getBoundingClientRect().bottom + 'px';
  }

  function openMenu() {
    var root = getRoot();
    if (!root) return;
    positionBelowHeader(root);
    root.classList.add(OPEN_CLASS);
    lockScroll(true);
    var toggle = getToggle();
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    var panel = root.querySelector('.mobile-menu__panel');
    if (panel) panel.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function closeMenu() {
    var root = getRoot();
    if (!root) return;
    root.classList.remove(OPEN_CLASS);
    lockScroll(false);
    var toggle = getToggle();
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', onKeydown);
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-mobile-menu-toggle]')) {
      event.preventDefault();
      var root = getRoot();
      if (root && root.classList.contains(OPEN_CLASS)) {
        closeMenu();
      } else {
        openMenu();
      }
      return;
    }
    if (event.target.closest('[data-mobile-menu-close]')) {
      event.preventDefault();
      closeMenu();
    }
  });
})();
